// ====================================================================== //
// History manager
// ====================================================================== //

// Force page reload on popstate

const selectors = {
    el: '.js-history-manager'
};

const classes = {
    ready: 'is-ready'
};

/**
 * @function `init`
 *
 * Initalizes the module.
 */
const init = () => {
    const el = document.querySelector(`${selectors.el}:not(.${classes.ready})`);
    if (!el) return;
    window.addEventListener('popstate', () => {
        history.go();
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;
